export function useAppSections(appSections) {
    const vSection = {
        mounted(el, binding) {
            if (!hasSection(binding.arg)) {
                el.style.display = 'none';
            }
        },
    };

    function getSections() {
        return appSections;
    }

    function hasSection(section) {
        return appSections.includes(section);
    }
    return {
        getSections,
        vSection,
        hasSection,
    };
}
